// request.ts
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

export default class HttpService {
  private axiosInstance: AxiosInstance;

  public retryCount: number = 3; // 默认重试次数

  constructor(baseURL: string = '') {
    this.axiosInstance = axios.create({
      baseURL,
      withCredentials: true,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });

    this.initializeResponseInterceptor();
  }

  public initializeResponseInterceptor() {
    this.axiosInstance.interceptors.response.use(
      (response) => this.handleResponse(response),
      (error) => this.handleError(error),
    );
  }

  public handleResponse({ data }: AxiosResponse) {
    return data;
  }

  public async handleError(error: any): Promise<any> {
    const config = error.config;
    if (!config || !this.shouldRetry(error)) {
      return Promise.reject(error);
    }

    config.__retryCount = config.__retryCount || 0;
    if (config.__retryCount >= this.retryCount) {
      return Promise.reject(error);
    }
    config.__retryCount += 1;

    // 以1秒，2秒，3秒的间隔请求重试
    const backoff = new Promise<void>((resolve) => {
      setTimeout(() => {
        resolve();
      }, 1000 * config.__retryCount);
    });

    // 等待退避时间过去，然后重试请求
    await backoff;
    return this.axiosInstance(config);
  }

  // 可选，你可以自定义此方法来决定在什么条件下应该重试请求
  public shouldRetry(error: any): boolean {
    // 这里你可以检查特定的HTTP状态码、网络错误等。
    // 例如，对于网络错误或5xx服务器错误重试
    if (!error.response || error.response.status >= 500) {
      return true;
    }
    return false;
  }

  public get<T>(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T, any>> {
    return this.axiosInstance.get<T>(url, config);
  }

  public post<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<T, any>> {
    return this.axiosInstance.post<T>(url, data, config);
  }
}
